import React from 'react';
import PropTypes from 'prop-types';

import { generateEntries, priceDescription, additionalDescription } from '@/utils/price';
import { PricingEntry } from '../pricingEntry/PricingEntry';

export const Pricing = ({ pricing, minimumOneWeekRental = false, firstColumnList, secondColumnList }) => {
    function showWeekPricingOnly(entry) {
        return entry.key !== 'week' && minimumOneWeekRental;
    }
    return (
        <div className="grid md:grid-cols-2 gap-16" data-testid="adPricing">
            <div className="grid gap-16" data-testid="entry-col-1">
                {generateEntries(priceDescription, pricing).map((entry) => {
                    if (showWeekPricingOnly(entry)) return null;
                    else return <PricingEntry key={`price-${entry.key}`} description={entry.description} value={entry.value} />;
                })}
                {Boolean(firstColumnList?.length) &&
                    firstColumnList.map(({ description, value }) => (
                        <PricingEntry key={`${description}-${value}`} description={description} value={value} />
                    ))}
            </div>

            <div className="grid gap-16" data-testid="entry-col-2">
                {generateEntries(additionalDescription, pricing).map((entry) => (
                    <PricingEntry key={`price-${entry.key}`} description={entry.description} value={entry.value} />
                ))}

                {Boolean(secondColumnList?.length) &&
                    secondColumnList.map(({ description, value }) => (
                        <PricingEntry key={`${description}-${value}`} description={description} value={value} />
                    ))}
            </div>
        </div>
    );
};

Pricing.propTypes = {
    pricing: PropTypes.object.isRequired,
    minimumOneWeekRental: PropTypes.bool,
    firstColumnList: PropTypes.arrayOf(
        PropTypes.shape({
            description: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        })
    ),
    secondColumnList: PropTypes.arrayOf(
        PropTypes.shape({
            description: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        })
    ),
};
